import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commPipe'
})
export class CommaPipe implements PipeTransform {
    private DECIMAL_SEPARATOR = '.';
    private THOUSANDS_SEPARATOR = ',';

    transform(value: number | string, fractionSize: number = 2): string {
      if (value == null || value == 0 || value == '')
        return '0';

      // noinspection TypeScriptValidateTypes
      let [integer] = (value || '').toString().split(this.DECIMAL_SEPARATOR);
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
      return integer;
    }

    transformWithNegative(value: number): string {
      if (value == null || value == 0)
        return '0';

      const subValue = value < 0 ? (0 - value) : value;

      let [integer] = (subValue || '').toString().split(this.DECIMAL_SEPARATOR);
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

      if (value < 0)
        return '('+ integer +')';
      else return integer;
    }

    transformDollar(value: number | string, fractionSize: number = 2): string {
      if (value == null || value == 0)
        return '0';

      // noinspection TypeScriptValidateTypes
      let [integer] = (value || '').toString().split(this.DECIMAL_SEPARATOR);
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
      if (value >= 0)
        return '$'+ integer;
      else return '-$'+ integer.replace('-','');
    }

    transformValue(value: number | string, fractionSize: number = 2): string {
      if (value == null || value == 0)
        return '0';

      // noinspection TypeScriptValidateTypes
      let [integer] = (value || '').toString().split(this.DECIMAL_SEPARATOR);
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
      return '$'+ integer;
    }

    parse(value: string, fractionSize: number = 2): string {
      let [ integer] = (value || '').split(this.DECIMAL_SEPARATOR);
      integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');
      return integer;
    }

}
